export default __webpack_public_path__ + "static/media/RomasSpecial.bf1374d3.jpg";